import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type HiddenAndArchivedModeState = {
  showHiddenMode: boolean;
  showArchivedMode: boolean;
};

type HiddenAndArchivedModeActions = {
  toggleHiddenMode: () => void;
  toggleArchivedMode: () => void;
  resetHiddenMode: () => void;
  resetArchivedMode: () => void;
};

const initialState: HiddenAndArchivedModeState = {
  showHiddenMode: false,
  showArchivedMode: false,
};

export const createHiddenAndArchivedModesSlice: WaterlyAppStateCreator<
  HiddenAndArchivedModeActions,
  HiddenAndArchivedModeState
> = (set, get) => ({
  ...initialState,
  toggleArchivedMode: () => {
    set({ showArchivedMode: !get().showArchivedMode });
  },
  toggleHiddenMode: () => {
    set({ showHiddenMode: !get().showHiddenMode });
  },
  resetHiddenMode: () => {
    set({ showHiddenMode: initialState.showHiddenMode });
  },
  resetArchivedMode: () => {
    set({ showArchivedMode: initialState.showArchivedMode });
  },
});
